import React from 'react';
import type { AnyObjectSchema } from 'yup';

import type {
  FieldValues,
  FormProps,
  GetOTPButtonProps,
  OTPInputProps,
} from '@sravni/react-silent-authentication-form';
import { ContextProvider } from '@sravni/react-silent-authentication-form';
import { UserManager } from '@sravni/utils/lib/auth';

import AuthSilentForm from './AuthSilentForm';

interface IAuthFormProps {
  classNameInputs?: string;
  source: string;
  onLogin: (data: any) => void;
  onSend?: () => void;
  onError?: FormProps['onError'];
  fields?: string[];
  inputBg?: OTPInputProps['background'];
  btnText?: string;
  btnColor?: GetOTPButtonProps['color'];

  additionalValidationSchema?: AnyObjectSchema;
  additionalValidationFields?: string[];

  customFieldsConfig?: Record<string, React.ComponentType>;
  customFieldProps?: Record<string, any>;
}

const AuthForm: React.FC<IAuthFormProps> = (props) => {
  const { source, onLogin, ...rest } = props;
  const userManager = new UserManager();

  const handleLogin = async (data: FieldValues) => {
    const userData = {
      phone: data.phone,
      name: data.name,
    };

    onLogin(userData);
  };

  return (
    <ContextProvider
      userManager={userManager}
      metaInfo={{
        customer: 'edu',
        productName: source,
      }}
    >
      <AuthSilentForm onLogin={handleLogin} {...rest} />
    </ContextProvider>
  );
};

export default AuthForm;
